import React from 'react';
import { Navigate } from 'react-router-dom';
import { useJWTAuth } from '../../contexts/useJWTAuth';
import { ProtectedRoute } from './ProtectedRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

/** Checks that the signed-in user has isPlatformAdmin before rendering children. */
const AdminGuard: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useJWTAuth();
  if (!user?.isPlatformAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

/** Route wrapper that requires authentication AND an @autar.ai email address. */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => (
  <ProtectedRoute>
    <AdminGuard>{children}</AdminGuard>
  </ProtectedRoute>
);
